export default __webpack_public_path__ + "static/om-29d4236ebb6a5e42757e3f2700611899.svg";